import { Box, Button, styled } from '@mui/material';
import { palette } from '../../theme/palette';

export const Root = styled(Box)`
  position: relative;
`;

export const NavButton = styled(Button)`
  padding: 5px;
  text-transform: capitalize;
  color: ${palette.custom.darkGrey};
  background: none;
  .MuiButton-startIcon {
    color: ${palette.primary.main};
    margin-left: 0px;
  }
  :hover {
    background: none;
  }
`;






